export default "__VITE_ASSET__kjZkaQQb__"